import { memo } from 'react';
import { useSendUserInput } from '../../../provider/socketContext';
import { useLoggerStore, useDisplayStore } from '../../../store/sceneStore';

function LoggingWidget() {
	const { data: display, setState: setDisplay } = useDisplayStore((s) => s);
	const logger = useLoggerStore();

	const sendUserInput = useSendUserInput();

	const onClickLoggerInfo = () => {
		const newDisplay = Object.assign({}, display);
		if (logger.status === '') {
			const msg = {
				type: 'user_input',
				text: 'record',
				value: 1,
			};
			newDisplay.logger = true;
			sendUserInput(msg);
			setDisplay(newDisplay);
		} else {
			const msg = {
				type: 'user_input',
				text: 'record',
				value: 0,
			};
			newDisplay.logger = false;
			sendUserInput(msg);
			setDisplay(newDisplay);
		}
	};

	const onClickUploadInfo = () => {
		const msg = {
			type: 'user_input',
			text: 'file_upload',
			value: 1,
		};
		if (logger.upload !== null) sendUserInput(msg);
	};

	const logger_status_check = logger.status === 'recording';

	return (
		<div>
			{!!logger.on && (
				<div className='record-wrap'>
					{!!logger.upload ? (
						<div className='ProgressBar'>
							<div
								className='Progress'
								style={{
									width: `${String(logger.upload_progress / 10) + 'vw'}`,
								}}
							>
								<p fontSize='20px'>{logger.upload_progress + '%'}</p>
							</div>
						</div>
					) : (
						<button
							type='button'
							className='Button upload'
							style={{
								fontSize: '32x',
								color: `${logger_status_check ? 'rgba(255,255,255,0)' : 'rgba(255,255,255,1)'}`,
								backgroundColor: 'rgba(0,0,0,0)',
							}}
							disabled={logger_status_check}
							onClick={onClickUploadInfo}
						>
							<i className='mdi mdi-36px mdi-cloud-upload'></i>
							<br></br>
						</button>
					)}
					{!!logger.upload && (
						<button
							type='button'
							className='Button'
							style={{
								color: '#ffffff',
								backgroundColor: 'rgba(0,0,0,0)',
							}}
						>
							<i
								className={`mdi mdi-36px ${logger.upload_progress !== 100 ? 'mdi-loading mdi-spin' : 'mdi-cloud-check'}`}
							></i>
							<br></br>
						</button>
					)}
					{!logger.upload && (
						<button
							type='button'
							className='record'
							onClick={onClickLoggerInfo}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								viewBox='0 0 95 95'
								style={{
									transition: `all 1s ease-in-out`,
									fill: `${logger_status_check ? 'rgba(255,0,0,0.8)' : 'rgba(200,200,200,0.8)'}`,
									animationDelay: `${logger_status_check ? '2s' : ''}`,
									animation: `${logger_status_check ? 'blink 2s linear infinite' : ''}`,
								}}
							>
								<title>record</title>
								<g data-name='Layer 2'>
									<g data-name='Layer 1'>
										<circle
											cx='47.76'
											cy='47.76'
											r='44.76'
											stroke='#fff'
											strokeMiterlimit='10'
											strokeWidth='6'
											fill='#1d1d1b'
										/>
										<circle
											cx='47.76'
											cy='47.76'
											r='33.11'
											fill={
												logger_status_check
													? 'rgba(255,0,0,0.8)'
													: 'rgba(200,200,200,0.8)'
											}
										/>
									</g>
								</g>
							</svg>
						</button>
					)}
					{!!logger_status_check && (
						<p
							className='recordtext'
							style={{
								animationDelay: '2s',
								animation: 'blink 2s linear infinite',
							}}
						>
							RECORDING...
						</p>
					)}
				</div>
			)}
		</div>
	);
}

export default memo(LoggingWidget);
